import { useQuery } from '@tanstack/react-query';
import api from '../../http';

export interface PublicPlanItem {
	_id: string;
	plan: {
		_id: string;
		name: string;
		price: number;
		interval: string;
		intervalCount: number;
		maxInstallments: number;
		paymentMethods: string[];
		advantages: string[];
		maxProps: number;
		maxSamples: number;
		gracePeriod: number | null;
		hierarchy: { role: string };
	};
}

export const useGetPublicPlans = (enabled = true) => {
	return useQuery({
		queryKey: ['public-plans'],
		queryFn: async () => {
			const { data } = await api.get('/landing/plan/findAllPublic');
			console.log(data)
			return data as PublicPlanItem[];
		},
		enabled,
	});
};
